import React, { Fragment, ReactNode } from "react";
import { Nullable } from "../../../../../types/utils";
import {
  OrderCategory,
  OrderCostingVersion,
  OrderStatus,
  TOrderCostV2,
  TOrderCostV3,
  TOrderCostV4, TOrderCostV5
} from "../../../../api/endpoints/Order";
import VolumeSummary from "././VolumeSummary";
import CostError from "./CostError";
import CostingVersion from "././CostingVersion";
import InformationCost from "./InformationCost";
import ServiceChargeCost from "./ServiceChargeCost";
import TotalCost from "./TotalCost";

interface IProps {
  cost: TOrderCostV2 | TOrderCostV3 | TOrderCostV4 | TOrderCostV5;
  currentCostingVersion?: Nullable<OrderCostingVersion>;
  orderCategory: OrderCategory;
  orderStatus: OrderStatus;
  annualTotalCostFootnoteRef?: string;
}

export interface OrderCostSummaryV2Props extends IProps {
  additionalContent?: ReactNode;
}

const OrderCostSummaryV2 = (props: OrderCostSummaryV2Props) => {
  const { additionalContent, cost, orderCategory, currentCostingVersion } = props;
  const { total_cost, error } = cost.data;

  if (error) {
    return <CostError error={error} />
  }

  if (!total_cost) {
    return null;
  }

  return (
    <Fragment>
      {
        (orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT) &&
        <VolumeSummary {...props} />
      }

      {
        orderCategory !== OrderCategory.ARCHIVE &&
        <InformationCost {...props} />
      }

      <ServiceChargeCost {...props} />

      <TotalCost {...props} />

      {
        additionalContent
      }

      {
        cost.data.ecquote_version &&
        <CostingVersion version={currentCostingVersion} ecquoteVersion={cost.data.ecquote_version}  />
      }
    </Fragment>
  )
}

export default OrderCostSummaryV2;
